<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5607 6.43934C21.1464 7.02513 21.1464 7.97487 20.5607 8.56066L11.5607 17.5607C10.9749 18.1464 10.0251 18.1464 9.43934 17.5607L4.93934 13.0607C4.35355 12.4749 4.35355 11.5251 4.93934 10.9393C5.52513 10.3536 6.47487 10.3536 7.06066 10.9393L10.5 14.3787L18.4393 6.43934C19.0251 5.85355 19.9749 5.85355 20.5607 6.43934Z"
      fill="currentColor"
    />
  </svg>
</template>
